define.alias("shared/components/shared/button/upgrade", "calendar/components/shared/button/upgrade");